import { withRouter } from 'react-router-dom';
import SubNavBarMobile from './SubNavBarMobile';
import SubNavBarMobileContainer from './SubNavBarMobile.container';

export default withRouter(SubNavBarMobileContainer(SubNavBarMobile));
